import { useCallback, useState } from 'react';
import { ButtonGroup } from '@scale/scaleui';
import { FontSizeClass, MAX_FONT_SIZE_VALUE, MIN_FONT_SIZE_VALUE, getFontSizeClass } from './utils';

type Props = {
  onChange: (fontSizeClass: FontSizeClass) => void;
};

const FontSizeSelector = ({ onChange }: Props) => {
  const [disableDecrease, setDisableDecrease] = useState<boolean>(true);
  const [disableIncrease, setDisableIncrease] = useState<boolean>(false);
  const [fontValue, setFontValue] = useState(0);

  const handleChange = useCallback(
    (value: number) => {
      if (value === MIN_FONT_SIZE_VALUE) setDisableDecrease(true);
      else setDisableDecrease(false);

      if (value === MAX_FONT_SIZE_VALUE) setDisableIncrease(true);
      else setDisableIncrease(false);

      const fontSizeClass = getFontSizeClass(value);
      onChange(fontSizeClass);
      setFontValue(value);
    },
    [onChange],
  );

  return (
    <ButtonGroup
      className="w-[150px] h-8"
      buttons={[
        {
          icon: 'font',
          iconSize: 'sm',
          label: 'Decrease',
          labelHidden: true,
          onClick: () => handleChange(fontValue - 1),
          className: 'flex-1 justify-center',
          disabled: disableDecrease,
        },
        {
          icon: 'font',
          iconSize: 'lg',
          label: 'Increase',
          labelHidden: true,
          onClick: () => handleChange(fontValue + 1),
          className: 'flex-1 justify-center',
          disabled: disableIncrease,
        },
      ]}
    />
  );
};

export default FontSizeSelector;
